var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMailSecure02(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 58,
    height: 58,
    viewBox: "0 0 58 58",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.918 18.125L24.0279 22.3286C28.1729 24.7793 29.8297 24.7793 33.9748 22.3286L41.0846 18.125",
    stroke: "#2C4A3A",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M30.207 47.1263C30.207 47.1263 24.3324 47.0968 21.9875 47.0379C14.3787 46.8467 10.5742 46.7512 7.84068 44.0074C5.10712 41.2632 5.02812 37.5592 4.87014 30.1507C4.81934 27.7686 4.81932 25.4007 4.87012 23.0186C5.02812 15.6102 5.1071 11.906 7.84066 9.16204C10.5742 6.41806 14.3787 6.32248 21.9875 6.13133C26.677 6.01351 31.3204 6.01351 36.0099 6.13135C43.6188 6.32253 47.4231 6.41811 50.1569 9.16207C52.8904 11.906 52.9694 15.6102 53.1272 23.0186C53.1526 24.2095 53.1654 26.6054 53.1654 27.793",
    stroke: "#2C4A3A",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M53.1667 41.0833V35.0417C48.3333 35.0417 44.7083 32.625 44.7083 32.625C44.7083 32.625 41.0833 35.0417 36.25 35.0417V41.0833C36.25 49.5417 44.7083 51.9583 44.7083 51.9583C44.7083 51.9583 53.1667 49.5417 53.1667 41.0833Z",
    stroke: "#2C4A3A",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMailSecure02);
export default __webpack_public_path__ + "static/media/mail-secure-02.1efa2c000c9b039f0b0a88874a97e844.svg";
export { ForwardRef as ReactComponent };